// /var/www/afra/web-design.rampagesoft.com/my-app/src/page/WebDesign.js

import React, { useEffect, useState } from "react";
import "../css/iwantto.scss";        // <-- นำสไตล์เดิมกลับมาใช้งาน
import MetaTAG from "../meta-tag";
import Banner from "../banner";
import Text5icon from "../component/text5icon.js";
import Detailphoto from "../component/detailphoto.js";
import Bannergarantee from "../bannergarantee";
import Detailphoto2 from "../component/detailphoto2.js";
import Spahotel from "../component/spahotel.js";
import Bgbanner from "../component/bg-banner.js";
import Packagewebsite from "../component/package-website.js";
import Slidebar from "../component/slidebar.js";
import FAQ from "../component/faq.js";
import TTTRAM from "../tttrampage";

import icontextData from "../data/icontextData.json";
import successStoriesData from "../data/successStories.json";
import bgBannerContent from "../data/bgBannerContent.json";
import detailPhotoContent from "../data/detailPhotoContent.json";
import spaHotelContent from "../data/spaHotelContent.json";
import appPackageContent from "../data/appPackageContent.json";

// ─── ปรับเส้นทางรูปภาพแพ็กเกจ ───────────────────────────────────────────────
const updatedCrmPackageContent = {
  ...appPackageContent,
  packages: appPackageContent.packages.map((pkg) => ({
    ...pkg,
    image: require(`../media/${pkg.image}`)
  }))
};

function WebDesign() {
  const [faqData, setFaqData] = useState(null);

  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/data/faqData.json`)
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP error: ${response.status}`);
        return response.json();
      })
      .then(setFaqData)
      .catch((err) => console.error("Error fetching faqData:", err));
  }, []);

  if (!faqData) return <div>Loading...</div>;

  return (
    <>
      <MetaTAG />
      <Banner />

      <Text5icon
        data={icontextData.services || []}
        headingText={icontextData.headingText}
      />

      <Detailphoto pageType="design" />
      <Bannergarantee />
      <Detailphoto2 content={detailPhotoContent} />
      <Spahotel content={spaHotelContent} />
      <Bgbanner heading={bgBannerContent.heading} />
      <Slidebar
        data={successStoriesData.services || []}
        heading={successStoriesData.headingText}
      />
      <Packagewebsite content={updatedCrmPackageContent} />
      <FAQ content={faqData} />
      <TTTRAM />
    </>
  );
}

export default WebDesign;
